import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=2f807988&scoped=true&"
import script from "./Doc.vue?vue&type=script&lang=js&"
export * from "./Doc.vue?vue&type=script&lang=js&"
import style0 from "./Doc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Doc.vue?vue&type=style&index=1&id=2f807988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f807988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f807988', component.options)
    } else {
      api.reload('2f807988', component.options)
    }
    module.hot.accept("./Doc.vue?vue&type=template&id=2f807988&scoped=true&", function () {
      api.rerender('2f807988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/Doc.vue"
export default component.exports